import { SellingPlan } from '../../models/selling-plan'
import { widgetState } from '../../store/customizations/index'
import { sortingByFrequency } from './frequency'
import { sortingByName } from './name'
import { sortingByPrice } from './price'

export const sortStrategy = (groupId: string): (a: SellingPlan, b: SellingPlan) => number => {
  switch (widgetState.customizations.sellingPlans.sort.strategy) {
    case 'name':
      return sortingByName
    case 'price':
      return sortingByPrice(groupId)
    case 'frequency':
      return sortingByFrequency
  }
}
